import script from "./ProfilePhoto.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilePhoto.vue?vue&type=script&setup=true&lang=js"

import "./ProfilePhoto.vue?vue&type=style&index=0&id=7957f3ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7957f3ac"]])

export default __exports__